import React, { createContext, useContext, useState, useEffect, useRef, setState } from 'react';
import { retailerFitGuide_storageKey } from './Script/RetailerFitGuide_Constants.js';
const AppStateContext = createContext();

const AppStateProvider = ({ children }) => {
  const [selectedSolution, setSelectedSolution] = useState();
  const [oldCarResult, setOldCarResult] = useState();
  const [newCarResult, setNewCarResult] = useState();
  const [notificationMessage, setNotificationMessage] = useState();
  const [productList, setProductList] = useState(() => {
    try {
      const savedProducts = localStorage.getItem(retailerFitGuide_storageKey);
      return savedProducts ? JSON.parse(savedProducts) : [];
    } catch (e) {
      console.error('[RetailerFitGuide] Failed to restore product list from localStorage', e);
      return [];
    }
  });

  const translations = _THULEDATA?.retailerFitGuide?.translations;

  useEffect(() => {
    localStorage.setItem(retailerFitGuide_storageKey, JSON.stringify(productList));
  }, [productList]);

  const clearSettings = () => {
    setOldCarResult(null);
    setNewCarResult(null);
    setSelectedSolution(null);
  };

  return (
    <AppStateContext.Provider
      value={{
        oldCarResult,
        setOldCarResult,
        newCarResult,
        setNewCarResult,
        selectedSolution,
        setSelectedSolution,
        clearSettings,
        productList,
        setProductList,
        translations,
        notificationMessage,
        setNotificationMessage,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

const useAppState = () => {
  const context = useContext(AppStateContext);
  if (!context) {
    throw new Error('useAppState must be used within an AppStateProvider');
  }
  return context;
};

export { AppStateProvider, useAppState };
